import { render, staticRenderFns } from "./FieldValue.vue?vue&type=template&id=1af12284&lang=pug"
import script from "./FieldValue.vue?vue&type=script&lang=js"
export * from "./FieldValue.vue?vue&type=script&lang=js"
import style0 from "./FieldValue.vue?vue&type=style&index=0&id=1af12284&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports